import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { siteConfig } from '../../config/siteConfig';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedSection, setExpandedSection] = useState('WHO WE ARE'); // Default expanded
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSection = (sectionName) => {
    setExpandedSection(expandedSection === sectionName ? null : sectionName);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo Section */}
        <div className="header-logo">
          <a href="/" className="logo-link">
            <img 
              src={siteConfig.images.logo.src} 
              alt={siteConfig.images.logo.alt}
              className="logo-image"
            />
          </a>
        </div>

        {/* Tagline Section */}
        <div className="header-tagline">
          <h1>{siteConfig.brand.tagline}</h1>
        </div>

        {/* Hamburger Menu Section */}
        <div className="header-menu">
          <button 
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>

      {/* Full-Screen Navigation Overlay */}
      <nav className={`navigation-overlay ${isMenuOpen ? 'navigation-overlay-open' : ''}`}>
        <div className="navigation-overlay-content">
          {/* Close Button */}
          <button 
            className="navigation-close" 
            onClick={toggleMenu}
            aria-label="Close navigation menu"
          >
            <i className="fas fa-times"></i>
          </button>

          {/* Navigation Menu */}
          <div className="navigation-menu">
            <ul className="navigation-list">
              {siteConfig.navigation.items.map((item, index) => (
                <li key={index} className="navigation-item">
                  {item.type === 'section' && item.hasSubmenu ? (
                    // Section with submenu
                    <div className="navigation-section">
                      <div 
                        className={`navigation-section-header ${expandedSection === item.name ? 'expanded' : ''}`}
                        onClick={() => toggleSection(item.name)}
                      >
                        <span className="navigation-section-title">{item.name}</span>
                        <span className="navigation-section-indicator">
                          {expandedSection === item.name ? '−' : '+'}
                        </span>
                      </div>
                      
                      <ul className={`navigation-submenu ${expandedSection === item.name ? 'expanded' : ''}`}>
                        {item.submenu.map((subItem, subIndex) => (
                          <li key={subIndex} className="navigation-subitem">
                            <a 
                              href={subItem.path}
                              className={`navigation-sublink ${location.pathname === subItem.path ? 'active' : ''}`}
                              onClick={handleLinkClick}
                            >
                              {subItem.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    // Regular link
                    <div className="navigation-link-wrapper">
                      <a 
                        href={item.path}
                        className={`navigation-link ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        <span className="navigation-link-title">{item.name}</span>
                        {item.subtitle && (
                          <span className="navigation-link-subtitle">{item.subtitle}</span>
                        )}
                      </a>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 